export default "June 6, 2022";